import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { Translate } from 'react-localize-redux';


interface GuideSectionProps {
    headerKey?: string;
    bodyKey?: string | string[];
    listBodyKeys?: string | string[];
    listBodyKeysSecondLevel?: string | string[];
    headerKeySecondLevel?: string;
}

interface GuideSectionState {
}

class GuideSection extends React.Component<GuideSectionProps, GuideSectionState> {
    constructor(props: GuideSectionProps) {
        super(props);
        bindAllOfThis(this, GuideSection.prototype);

        this.state = {
        };
    }

    generateSecondLevelList() {
        if (!this.props.listBodyKeysSecondLevel) {
            return null;
        }
        
        return (
            <ul className="sublist">
                    {
                        typeof this.props.listBodyKeysSecondLevel === 'string'
                            ? <li>
                                <Translate id={this.props.listBodyKeysSecondLevel} />
                            </li>
                            : this.props.listBodyKeysSecondLevel.map((bodyKey, index) => {
                                return <li key={bodyKey + index}>
                                    <Translate id={bodyKey} />
                                </li>;
                            })
                    }
                </ul>
        );
    }

    render() {
        return <div className="guide-section">
            {
                this.props.headerKey &&
                <h3><Translate id={this.props.headerKey} /></h3>
            }
            {
                this.props.bodyKey &&
                (
                    typeof this.props.bodyKey === 'string'
                        ? <p><Translate id={this.props.bodyKey} /></p>
                        : this.props.bodyKey.map((bodyKey, index) => {
                            return <p key={bodyKey + index}>
                                <Translate id={bodyKey} />
                            </p>;
                        })
                )
            }
            {
                this.props.listBodyKeys &&
                (
                    <ul>
                        {
                            typeof this.props.listBodyKeys === 'string'
                                ? <li>
                                    <Translate id={this.props.listBodyKeys} />
                                </li>
                                : this.props.listBodyKeys.map((bodyKey, index) => {
                                    return <li key={bodyKey + index}>
                                        <Translate id={bodyKey} />
                                    </li>;
                                })
                        }
                    </ul>
                )
            }
            {
                this.props.headerKeySecondLevel && 
                this.props.listBodyKeysSecondLevel && 
                (typeof this.props.listBodyKeysSecondLevel === 'string' || 
                 (Array.isArray(this.props.listBodyKeysSecondLevel) && this.props.listBodyKeysSecondLevel.length > 0)) &&
                <p><Translate id={this.props.headerKeySecondLevel} /></p>
            }
            {this.generateSecondLevelList()}
            {
                this.props.children
            }
        </div>;
    }
}

export default GuideSection;



// WEBPACK FOOTER //
// ./src/components/public/GuideSection.tsx